import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryMediaHear extends EventRegistryCategory {
    label = 'Hear';
    constructor(parent) {
        super(parent);
        super.init();
    }
    recognitionresult = () => new EventRegistryItem({ handlerName: 'onRecognitionResult' });
    mannerexecution = () => new EventRegistryItem({ handlerName: 'onMannerExecution' });
}
